"use client";
import { useRecentlyViewed } from "@/hooks/use-recently-viewed";
export default function RecentlyViewedTracker({ id }: { id: number }) {
  useRecentlyViewed(id);
  return null;
}
